<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-66 mx-auto md-small-size-100">
        <md-card>
          <md-card-header data-background-color="purple">
            <h4 class="title">Blink Offer App</h4>
            <p class="category">
              This app is still in development mode. some features and functions
              may not work
            </p>
          </md-card-header>

          <md-card-content>
            <p>
              Hi welcome to blinkoffr, This app is an awesome offers posting
              software that gets you the best offers at the right time around
              you
            </p>
            <p>
              Blink Offr uses location based and taste filter suggestions to
              show you the best offers around you.
            </p>
            <p>
              The data collected is not shared to any third party entity and you
              own the full right to create and delete an account.
            </p>
            <p>
              Accounts may be suspended due to suspicious activity as we require
              real and honest buyers in our app
            </p>
            <p>
              The app is currently on development mode and will be available
              soon to the public. If you are one of the internal testers click
              the link below
            </p>

            <md-button
              target="_blank"
              href="https://play.google.com/apps/testing/com.lucemanb.blinkoffr"
              class="md-round centify md-size-100 purple"
              >DOWNLOAD</md-button
            >
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.md-card {
  margin-top: 50px;
}

.centify {
  margin: auto;
  width: 100%;
  background-color: purple;
}
</style>
